import React from "react";

const toneClasses = {
  amber: "border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-500/50 dark:bg-amber-900/30 dark:text-amber-100",
  emerald:
    "border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-500/50 dark:bg-emerald-900/30 dark:text-emerald-100",
  sky: "border-sky-200 bg-sky-50 text-sky-800 dark:border-sky-500/50 dark:bg-sky-900/30 dark:text-sky-100",
  rose: "border-rose-200 bg-rose-50 text-rose-800 dark:border-rose-500/50 dark:bg-rose-900/30 dark:text-rose-100",
  slate:
    "border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-600/60 dark:bg-slate-800/50 dark:text-slate-100",
};

export default function ChildStatusBadge({ label, tone = "slate", children }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold ${toneClasses[tone] || toneClasses.slate}`}
    >
      {label}
      {children}
    </span>
  );
}
